import UserRoute from './UserRoute';

export default {
  name: 'User Management',
  location: '/users',
  component: UserRoute,
};
